import * as React from 'react'
import { FaIcon, faChartPieSimpleSolid } from '@/lib/fa'
import { getActivityIcon } from '../../resolves/activityIconResolver'
import { getActivityName } from '../../resolves/activityNameResolver'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import {
  formatDateTime,
  getDurationBetweeenDates,
} from '@/app/common/dateHelper'
import ActivityListRowItem from './ActivityListRowItem'

const ActivityListRow = React.forwardRef<
  HTMLTableRowElement,
  {
    activity: any
    onShowChart?: () => void
    onMouseEnter?: () => void
    onMouseLeave?: () => void
    isHovered?: boolean
  }
>(({ activity, onShowChart, onMouseEnter, onMouseLeave, isHovered }, ref) => {
  const { t } = useLocalize()
  const yes = t('answer.yes')
  const no = t('answer.no')
  return (
    <tr
      ref={ref}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`notches-border--right tw-w-fit tw-cursor-pointer tw-border-b tw-bg-white hover:tw-bg-primary/10 ${
        isHovered ? 'tw-bg-primary/10' : ''
      }`}
    >
      <ActivityListRowItem
        size="small"
        bolder={false}
        icon={
          <FaIcon
            icon={getActivityIcon(activity?.type)}
            className="tw-h-3 tw-w-3 tw-text-content-base"
          />
        }
      >
        <span className="tw-inline-flex tw-items-center tw-gap-1.5">
          {t(getActivityName(activity.type))}
          {onShowChart && (
            <button
              type="button"
              title={t('driverModule.show-chart')}
              onClick={(e) => {
                e.stopPropagation()
                onShowChart()
              }}
              className="tw-inline-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded tw-text-primary hover:tw-bg-primary/10"
            >
              <FaIcon
                icon={faChartPieSimpleSolid}
                className="tw-h-3.5 tw-w-3.5"
              />
            </button>
          )}
        </span>
      </ActivityListRowItem>
      <ActivityListRowItem size="small" bolder={false}>
        {formatDateTime(activity.startTime)}
      </ActivityListRowItem>
      <ActivityListRowItem size="small" bolder={false}>
        {formatDateTime(activity.endTime)}
      </ActivityListRowItem>
      <ActivityListRowItem size="small" bolder={false}>
        {getDurationBetweeenDates(activity.startTime, activity.endTime)}
      </ActivityListRowItem>
      <ActivityListRowItem bolder={false} size="small">
        {activity?.registrationNumber}
      </ActivityListRowItem>
      <ActivityListRowItem bolder={false} size="small">
        {activity?.isCrew === true ? yes : no}
      </ActivityListRowItem>
      <ActivityListRowItem bolder={false} size="small">
        {activity?.isFerryCrossing === true ? yes : no}
      </ActivityListRowItem>
      <ActivityListRowItem bolder={false} size="small">
        {activity?.isOutOfScope === true ? yes : no}
      </ActivityListRowItem>
      <ActivityListRowItem bolder={false} size="small">
        {activity?.isManualEntry === true ? yes : no}
      </ActivityListRowItem>
    </tr>
  )
})

ActivityListRow.displayName = 'ActivityListRow'

export default ActivityListRow
